import { t as formActionTypes } from 'modules/catalogForm';
import {
  FETCH_CATALOGS_REQUEST,
  FETCH_CATALOGS_RESPONSE,
  FETCH_CATALOGS_ERROR,
  REMOVE_CATALOG_REQUEST,
  REMOVE_CATALOG_RESPONSE,
  REMOVE_CATALOG_ERROR,
  REMOVE_CATALOG_ITEM_REQUEST,
  REMOVE_CATALOG_ITEM_RESPONSE,
  REMOVE_CATALOG_ITEM_ERROR,
  CREATE_CATALOG_REQUEST,
  CREATE_CATALOG_RESPONSE,
  CREATE_CATALOG_ERROR,
  FETCH_CATALOG_NAMES_REQUEST,
  FETCH_CATALOG_NAMES_RESPONSE,
  FETCH_CATALOG_NAMES_ERROR,
  FETCH_PAGINATED_CATALOG_ITEMS_REQUEST,
  FETCH_PAGINATED_CATALOG_ITEMS_RESPONSE,
  FETCH_PAGINATED_CATALOG_ITEMS_ERROR,
  UPDATE_CATALOG_DISPLAY_SETTING,
} from './actionTypes';

const initialCatalogTableState = {
  dataList: [],
  dataObj: {},
  isLoading: false,
  isSubmittingForm: false,
  pending: { tables: [] },
  pendingDelete: { tables: {} },
  filters: { page: 1, pageSize: 20 },
  total: 0,
  sizeInBytes: -1,
  isDisplayTable: false,
};

const catalogTableReducer = (state = initialCatalogTableState, action) => {
  switch (action.type) {
    case FETCH_CATALOGS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_CATALOGS_RESPONSE:
      return {
        ...state,
        dataList: action.dataList,
        dataObj: action.dataObj,
        pending: action.pending,
        isLoading: false,
        tableName: '',
        filters: { page: 1, pageSize: 20 },
      };
    case FETCH_CATALOGS_ERROR:
      return {
        ...state,
        isLoading: false,
        tableName: '',
      };
    case REMOVE_CATALOG_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case REMOVE_CATALOG_RESPONSE:
      return {
        ...state,
        dataList: action.dataList,
        dataObj: action.dataObj,
        isLoading: false,
      };
    case REMOVE_CATALOG_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case REMOVE_CATALOG_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case REMOVE_CATALOG_ITEM_RESPONSE:
      return {
        ...state,
        isLoading: false,
        pendingDelete: action.pendingDelete,
      };
    case REMOVE_CATALOG_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case CREATE_CATALOG_REQUEST:
      return {
        ...state,
        isSubmittingForm: true,
      };
    case CREATE_CATALOG_RESPONSE:
      return {
        ...state,
        isSubmittingForm: false,
        pending: action.pending,
      };
    case CREATE_CATALOG_ERROR:
      return {
        ...state,
        isSubmittingForm: false,
        error: action.error,
      };
    case FETCH_CATALOG_NAMES_REQUEST:
      return {
        ...state,
        isSubmittingForm: true,
      };
    case FETCH_CATALOG_NAMES_RESPONSE:
      return {
        ...state,
        isSubmittingForm: false,
        dataObj: action.dataObj,
      };
    case FETCH_CATALOG_NAMES_ERROR:
      return {
        ...state,
        isSubmittingForm: false,
        error: action.error,
      };
    case FETCH_PAGINATED_CATALOG_ITEMS_REQUEST:
      return {
        ...state,
        tableName: action.tableName,
        isLoading: true,
      };
    case FETCH_PAGINATED_CATALOG_ITEMS_RESPONSE:
      return {
        ...state,
        isLoading: false,
        dataList: action.dataList,
        dataObj: action.dataObj,
        filters: action.filters,
        pending: action.pending,
        total: action.total,
        sizeInBytes: action.sizeInBytes,
      };
    case FETCH_PAGINATED_CATALOG_ITEMS_ERROR:
      return {
        ...state,
        isLoading: false,
        tableName: '',
      };
    case formActionTypes.UPDATE_CATALOG_ITEM_REQUEST:
      return {
        ...state,
        isSubmittingForm: true,
      };
    case formActionTypes.UPDATE_CATALOG_ITEM_RESPONSE:
      return {
        ...state,
        isSubmittingForm: false,
        pending: action.pending,
        pendingDelete: action.pendingDelete,
      };
    case formActionTypes.UPDATE_CATALOG_ITEM_ERROR:
      return {
        ...state,
        error: action.error,
        isSubmittingForm: false,
      };
    case formActionTypes.UPDATE_BULK_CATALOG_ITEMS_REQUEST:
      return {
        ...state,
        isSubmittingForm: true,
      };
    case formActionTypes.UPDATE_BULK_CATALOG_ITEMS_RESPONSE:
      return {
        ...state,
        isSubmittingForm: false,
      };
    case formActionTypes.UPDATE_BULK_CATALOG_ITEMS_ERROR:
      return {
        ...state,
        error: action.error,
        isSubmittingForm: false,
      };
    case UPDATE_CATALOG_DISPLAY_SETTING:
      return {
        ...state,
        isDisplayTable: action.isDisplayTable,
      };
    default: {
      return state;
    }
  }
};

export default catalogTableReducer;
